import './App.scss'

import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { Configure, InstantSearch } from 'react-instantsearch'

import RoamingBundles from './bundleCard/RoamingBundles'
import CountrySearch from './countrySearch/CountrySearch'
import ResourceEnvironment from './hook/ResourceEnvironment'
import { BMToken } from './hook/Token'
import { useState } from 'react'
import { getIndexForAddOns } from './utils';

const searchClient = algoliasearch('A47E3BWDPH', 'e5c93dfd73b094a9553e9a07349b774e')

function App() {
  const [env, setEnv] = useState(false);
  const [bmToken, setBMToken] = useState(false);

  const win: any = window;
  const environment = win["env_variable"];
  const indexName = getIndexForAddOns(environment);

  return (
    <div className="App terms-conditions mt-5 mb-5">
      <ResourceEnvironment setEnv={setEnv} />
      <BMToken setBMToken={setBMToken} />
      {env && bmToken && <InstantSearch searchClient={searchClient} indexName={indexName}>
        <Configure hitsPerPage={1000} />
        <RoamingBundles />
        <CountrySearch />
      </InstantSearch>}
    </div>
  )
}

export default App
